<template>
  <div
    class="tag"
    v-bind:class="{
      'tag--info': status == '-1',
      'tag--success': status == '0',
      'tag--danger': status == '1',
      'tag--large': true
    }"
  >
    {{ label }}
  </div>
</template>
<style></style>
<script>
export default {
  name: "status-tag",
  props: {
    status: Number,
    label: String
  }
};
</script>
